import type { FdmFile, PartialNodeWithProperties } from '@cognite/apm-client';
import type { FileInfo } from '@cognite/sdk';

import { isRecord } from '../../utils/type-guards';

export const supportedDocumentMimeTypes = [
  'text/plain',
  'text/csv',
  'application/json',
  'application/pdf',
  'image/svg+xml',
];

export const isSupportedDocumentType = (
  document: FdmFile | PartialNodeWithProperties,
  isAkerbpCustomCode: boolean
) => {
  const mimeType =
    typeof document.mimeType === 'string' ? document.mimeType : '';
  // Check if the document's mimeType is supported
  if (!supportedDocumentMimeTypes.includes(mimeType)) {
    return false;
  }

  // If isAkerbpCustomCode is true, filter out documents with 'WORKFLOW STATUS' metadata set to 'Void'
  if (isAkerbpCustomCode && isRecord(document.metadata)) {
    const workflowStatus = document.metadata['WORKFLOW STATUS'];

    if (typeof workflowStatus === 'string') {
      const status = workflowStatus.toLowerCase();
      return status !== 'void' && status !== 'removed';
    }
  }

  // If none of the above conditions are met, include the document
  return true;
};

export const toFdmFile = (file: FileInfo): FdmFile => {
  return {
    ...file,
    externalId: file.externalId || '',
  };
};
